import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import { ErrorMessage } from '../Input/Input.styles'
import { Option } from '../NativeSelect/NativeSelect.types'
import {
  OptionContent,
  OptionLabel,
  OptionWrapper,
  Wrapper,
} from './OptionSelector.styles'

export interface Props {
  optionList: Option[]
  textLabel?: string
  onChange?: (event) => void
}
interface State {
  currentOptionSelected: string | number
}

class OptionSelectorField extends React.Component<
  Props & FieldProps & React.InputHTMLAttributes<any>,
  State
> {
  state = {
    currentOptionSelected: this.props.form.values[this.props.field.name],
  }

  static getDerivedStateFromProps(props, state) {
    return {
      currentOptionSelected: props.form.values[props.field.name],
    }
  }

  onOptionClick = event => {
    const { field, form } = this.props
    this.setState({ currentOptionSelected: event.currentTarget.value })
    form.setFieldTouched(field.name)
    form.setFieldValue(field.name, event.currentTarget.value)
    if (this.props.onChange) this.props.onChange(event)
  }

  render() {
    const { currentOptionSelected } = this.state
    const { field, form, optionList, textLabel } = this.props
    const hasError = Boolean(
      form.touched[field.name] && form.errors[field.name],
    )

    return (
      <>
        {textLabel && (
          <QuestionWrapper as="div" color="black" marginBottom="xxxs">
            {textLabel}
          </QuestionWrapper>
        )}
        <Wrapper>
          {optionList.map((option, index) => (
            <OptionWrapper
              key={index}
              isSelected={option.value === currentOptionSelected}
            >
              <OptionLabel isSelected={option.value === currentOptionSelected}>
                {option.text}
              </OptionLabel>
              <OptionContent
                {...field}
                value={option.value}
                type={
                  typeof optionList[0].value === 'number' ? 'number' : 'radio'
                }
                onClick={event => {
                  form.setFieldValue(field.name, event.currentTarget.value)
                  this.onOptionClick(event)
                  field.onChange(event)
                }}
              />
            </OptionWrapper>
          ))}
        </Wrapper>
        {hasError && <ErrorMessage>{form.errors[field.name]}</ErrorMessage>}
      </>
    )
  }
}

export default OptionSelectorField
